export enum SignAuthType {
    NONE = 'NONE',
    SEND = 'SEND',
    COMPLETE = 'COMPLETE',
    EXPIRED = 'EXPIRED',
    ERROR = 'ERROR',
}